"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumPowerPortLocalNamingRule = void 0;
const AltiumLabelTypeNameUtil_1 = require("./AltiumLabelTypeNameUtil");
const AltiumNetLocalNamingRule_1 = require("./AltiumNetLocalNamingRule");
class AltiumPowerPortLocalNamingRule extends AltiumNetLocalNamingRule_1.AltiumNetLocalNamingRule {
    apply(hierarchy) {
        this.recombobulatePowerPortsWithPorts(hierarchy);
    }
    recombobulatePowerPortsWithPorts(hierarchy) {
        if (hierarchy.instance.isMultiChannel || hierarchy.instance.totalSheetInstances > 1) {
            this.renamePowerPortsConnectedToPorts(hierarchy);
        }
        for (const child of hierarchy.children) {
            this.recombobulatePowerPortsWithPorts(child);
        }
    }
    renamePowerPortsConnectedToPorts(hierarchy) {
        const powerPorts = new Map();
        for (const obj of hierarchy.combobulator.defaultDimension.iterateLabelObjects('power-port')) {
            const label = obj.label;
            if (label?.labelType === 'power-port') {
                const powerPortName = label.formattedLabel ?? label.originalLabel;
                const ports = powerPorts.get(powerPortName) ?? [];
                ports.push(label);
                powerPorts.set(powerPortName, ports);
            }
        }
        for (const powerPortObjs of powerPorts.values()) {
            const portConnectedObjects = new Map();
            for (const powerPort of powerPortObjs) {
                const connectedObjs = Array.from(hierarchy.combobulator.defaultDimension.getObjectsConnectedToPosition(powerPort.position));
                const connectedPortObjects = connectedObjs.filter((o) => o.label?.labelType === 'port');
                const usePortNetObject = connectedPortObjects[0];
                if (!usePortNetObject?.label) {
                    continue;
                }
                portConnectedObjects.set(powerPort, usePortNetObject.label);
            }
            if (portConnectedObjects.size === 0) {
                continue;
            }
            for (const powerPort of powerPortObjs) {
                const useName = this.namingStrategy.formatChannelLocalPowerPortName(powerPort, hierarchy.combobulator.instance);
                powerPort.formattedLabel = AltiumLabelTypeNameUtil_1.AltiumLabelTypeNameUtil.getLabelTypeName(powerPort.labelType, useName);
            }
        }
    }
}
exports.AltiumPowerPortLocalNamingRule = AltiumPowerPortLocalNamingRule;
//# sourceMappingURL=AltiumPowerPortLocalNamingRule.js.map